import React, { ReactNode } from 'react';
import { useChatAccess, UseChatAccessOptions } from '@/hooks/useChatAccess';
import ChatBlockedState from './ChatBlockedState';

interface ChatAccessGateProps {
  options: UseChatAccessOptions;
  children: ReactNode;
}

const ChatAccessGate = ({ options, children }: ChatAccessGateProps) => {
  const access = useChatAccess(options);

  if (access.isLoading) {
    return (
      <ChatBlockedState
        isLoading={true}
        missingRequirements={[]}
      />
    );
  }

  if (!access.allowed) {
    return (
      <ChatBlockedState
        message={options.context === 'conversation' ? `para conversar com ${options.targetUsername}` : 'para acessar o chat'}
        username={options.targetUsername}
        isLoading={false}
        missingRequirements={access.missingRequirements}
        nextActionUrl={access.nextActionUrl}
        nextActionLabel={access.nextActionLabel}
        secondaryActionUrl="/main/feed"
        secondaryActionLabel="Voltar ao Feed"
        isUserBlocked={access.isUserBlocked}
      />
    );
  }

  return <>{children}</>;
};

export default ChatAccessGate;
